// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"8e7d449b","352":"275b6662","453":"0792c422","727":"a07fa9f4"}[chunkId] + ".chunk.js";
};